import { render } from "./WebError403.vue?vue&type=template&id=ee7b4304"
const script = {}

import "./WebError403.vue?vue&type=style&index=0&id=ee7b4304&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__